import {useEffect} from "react";

const useTheme = (setTheme) => {
	useEffect(() => {
		const stored = window.localStorage.getItem("catsoup-radio-theme");
		if (stored === "light" || stored === "dark") {
			setTheme(stored);
			document.documentElement.setAttribute("data-theme", stored);
			return;
		}

		const prefersDark =
			window.matchMedia &&
			window.matchMedia("(prefers-color-scheme: dark)").matches;
		const initial = prefersDark ? "dark" : "light";
		setTheme(initial);
		document.documentElement.setAttribute("data-theme", initial);
	}, []);
}
export default useTheme;